import { IconFilePencil, } from '@tabler/icons';

// constant
const icons = {
    IconFilePencil,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const FeedbackPages = {
    id: 'Feedback management',
    title: 'Feedback management',
    caption: 'manage Feedback list',
    type: 'group',
    children: [
        {
            id: 'fetchFeedback',
            title: 'feedback',
            type: 'item',
            url: '/feedback/view',
            icon:icons.IconFilePencil
        }
    ],

};

export default FeedbackPages;